import * as PIXI from "@pixi/assets";

const BASE_PATH = "/assets";

const symbolSpines = Array.from({ length: 13 }, (_, i) => ({
  name: `sym${String(i + 1).padStart(2, "0")}`,
  json: `${BASE_PATH}/spines/symbols/sym${String(i + 1).padStart(2, "0")}.json`,
}));

export const ASSETS = {
  textures: [
    {
      name: "progressBarSpriteSheet",
      url: `${BASE_PATH}/loaderAssets/loaderAssets.json`,
    },
    {
      name: "mainBackgroundPortrait",
      url: `${BASE_PATH}/images/background-portrait.png`,
    },
    {
      name: "mainBackgroundLandscape",
      url: `${BASE_PATH}/images/background-landscape.png`,
    },
    {
      name: "featureBackgroundPortrait",
      url: `${BASE_PATH}/images/feature-background-portrait.png`,
    },
    {
      name: "featureBackgroundLandscape",
      url: `${BASE_PATH}/images/feature-background-landscape.png`,
    },
    {
      name: "reelFrameBack",
      url: `${BASE_PATH}/images/reel-frame-back.png`,
    },
    {
      name: "mainReelFrameFront",
      url: `${BASE_PATH}/images/reel-frame-front.png`,
    },
    {
      name: "featureReelFrameFront",
      url: `${BASE_PATH}/images/feature-reel-frame-front.png`,
    },
    {
      name: "reelBottom",
      url: `${BASE_PATH}/images/reels-bottom.png`,
    },
    {
      name: "featureReelBottom",
      url: `${BASE_PATH}/images/feature-reels-bottom.png`,
    },

    {
      name: "symbols",
      url: `${BASE_PATH}/newspritesheets/symbols_resized.json`,
    },
    {
      name: "logo",
      url: `${BASE_PATH}/images/logo.png`,
    },
    {
      name: "linesLandscape",
      url: `${BASE_PATH}/images/lines-landscape.png`,
    },
    {
      name: "linesPortrait",
      url: `${BASE_PATH}/images/lines-portrait.png`,
    },
    {
      name: "displayBackground",
      url: `${BASE_PATH}/images/display-background.png`,
    },
    {
      name: "featureDisplayBackground",
      url: `${BASE_PATH}/images/feature-display-background.png`,
    },
    {
      name: "freeSpinsText",
      url: `${BASE_PATH}/images/free-spins-text.png`,
    },

    {
      name: "JACKPOT_SILVER",
      url: `${BASE_PATH}/images/jackpot-silver.png`,
    },
    {
      name: "JACKPOT_GOLD",
      url: `${BASE_PATH}/images/jackpot-gold.png`,
    },
    {
      name: "JACKPOT_DIAMOND",
      url: `${BASE_PATH}/images/jackpot-diamond.png`,
    },
  ],
  spineAnimations: [
    {
      name: "background",
      json: `${BASE_PATH}/spines/reelsBackground/Background.json`,
    },
    {
      name: "winCelebration",
      json: `${BASE_PATH}/spines/Win_celebration/Win_celebration.json`,
    },
    {
      name: "winBox",
      json: `${BASE_PATH}/spines/Win_Box/Win_Box.json`,
    },
    {
      name: "freeSpinStart",
      json: `${BASE_PATH}/spines/FSDialogs/congratulations.json`,
    },
    {
      name: "freeSpinEnd",
      json: `${BASE_PATH}/spines/FSDialogs/congratulationsEnd.json`,
    },
    ...symbolSpines,
  ],

  bitmapFonts: [
    {
      name: "silver",
      json: `${BASE_PATH}/fonts/silver/jackpot-silver.fnt`,
    },
    {
      name: "gold",
      json: `${BASE_PATH}/fonts/gold/jackpot-gold.fnt`,
    },
    {
      name: "diamond",
      json: `${BASE_PATH}/fonts/diamond/jackpot-diamond.fnt`,
    },
  ],
};

export const ASSET_NAME = {
  progressBarSpriteSheet: `${BASE_PATH}/loaderAssets/loaderAssets.json`,
  progressBar: "progressBar.png",
  progressBarBackground: "progressBarBackground.png",
  loaderLogo: "slotGarten.png",
  mainBackgroundPortrait: `${BASE_PATH}/images/background-portrait.png`,
  mainBackgroundLandscape: `${BASE_PATH}/images/background-landscape.png`,
  featureBackgroundPortrait: `${BASE_PATH}/images/feature-background-portrait.png`,
  featureBackgroundLandscape: `${BASE_PATH}/images/feature-background-landscape.png`,
  symbols: `${BASE_PATH}/newspritesheets/symbols_resized.json`,
  reelFrameBack: `${BASE_PATH}/images/reel-frame-back.png`,
  mainReelFrameFront: `${BASE_PATH}/images/reel-frame-front.png`,
  featureReelFrameFront: `${BASE_PATH}/images/feature-reel-frame-front.png`,
  reelBottom: `${BASE_PATH}/images/reels-bottom.png`,
  featureReelBottom: `${BASE_PATH}/images/feature-reels-bottom.png`,
  linesPortrait: `${BASE_PATH}/images/lines-portrait.png`,
  linesLandscape: `${BASE_PATH}/images/lines-landscape.png`,
  logo: `${BASE_PATH}/images/logo.png`,
  displayBackground: `${BASE_PATH}/images/display-background.png`,
  featureDisplayBackground: `${BASE_PATH}/images/feature-display-background.png`,
  freeSpinsText: `${BASE_PATH}/images/free-spins-text.png`,
  JACKPOT_SILVER: `${BASE_PATH}/images/jackpot-silver.png`,
  JACKPOT_GOLD: `${BASE_PATH}/images/jackpot-gold.png`,
  JACKPOT_DIAMOND: `${BASE_PATH}/images/jackpot-diamond.png`,
  background: `${BASE_PATH}/spines/reelsBackground/Background.json`,
  silver: `${BASE_PATH}/fonts/silver/jackpot-silver.fnt`,
  gold: `${BASE_PATH}/fonts/gold/jackpot-gold.fnt`,
  diamond: `${BASE_PATH}/fonts/diamond/jackpot-diamond.fnt`,
  winCelebration: `${BASE_PATH}/spines/Win_celebration/Win_celebration.json`,
  winBox: `${BASE_PATH}/spines/Win_Box/Win_Box.json`,
  freeSpinStart: `${BASE_PATH}/spines/FSDialogs/congratulations.json`,
  freeSpinEnd: `${BASE_PATH}/spines/FSDialogs/congratulationsEnd.json`,
  sym01: `${BASE_PATH}/spines/symbols/sym01.json`,
  sym02: `${BASE_PATH}/spines/symbols/sym02.json`,
  sym03: `${BASE_PATH}/spines/symbols/sym03.json`,
  sym04: `${BASE_PATH}/spines/symbols/sym04.json`,
  sym05: `${BASE_PATH}/spines/symbols/sym05.json`,
  sym06: `${BASE_PATH}/spines/symbols/sym06.json`,
  sym07: `${BASE_PATH}/spines/symbols/sym07.json`,
  sym08: `${BASE_PATH}/spines/symbols/sym08.json`,
  sym09: `${BASE_PATH}/spines/symbols/sym09.json`,
  sym10: `${BASE_PATH}/spines/symbols/sym10.json`,
  sym11: `${BASE_PATH}/spines/symbols/sym11.json`,
  sym12: `${BASE_PATH}/spines/symbols/sym12.json`,
  sym13: `${BASE_PATH}/spines/symbols/sym13.json`,
};
export const getAsset = (status, assetName) =>
  status === "succeeded" ? PIXI.Assets.get(assetName) : null;
